<div class="page_title">
    <div class="row marges">
        <div class="col y_items_center">
            <h1 class="title">{{ 'services.session.identityVerification.title.value' | translate }}</h1>
        </div>
    </div>
</div>

<div>
    <div class="row marges ligne_form">
        <div class="col_12">
            <div class="form_paymment_reponse">
                <p class="title" [ngClass]="response">{{ `services.session.identityVerification.${response}.title.value` | translate }}</p>
            </div>
        </div>
    </div>

    <div class="row marges ligne_form">
        <div class="col_12">
            <div class="form_paymment_reponse">
                <p>{{ `services.session.identityVerification.${response}.${status}.content.value` | translate }}</p>
            </div>
        </div>
    </div>

    @if(sessionId) {

        <div class="row marges ligne_form">
            <div class="col_12">
                <div class="form_paymment_reponse">
                    <p>{{ 'services.session.identityVerification.sessionId.value' | translate }} : <strong>{{ sessionId }}</strong></p>
                </div>
            </div>
        </div>
    }
</div>

<div class="row marges ligne_form">
    <div class="col_12">
        <div class="form_paymment_reponse">
            <button class="btn_cta btn_little" type="button" (click)="goToMangoPayDocuments()">{{ 'services.session.identityVerification.documents.btn.value' | translate }}</button>
        </div>
    </div>
</div>
